export const CONTRACT = {
    B2B: "B2B",
    UCP: "UCP",
    UOP: "UOP",
    UNSET: "UNSET",
};

export const CONTRACT_DICTIONARY = {
    [CONTRACT.B2B]: "B2B",
    [CONTRACT.UCP]: "UCP",
    [CONTRACT.UOP]: "UOP",
    [CONTRACT.UNSET]: "Unset",
};

export const SPECIFIC_CONTRACT_DICTIONARY = {
    [CONTRACT.UOP]: "UOP",
    [CONTRACT.UCP]: "UCP",
};
